import { Theme, styled } from '@mui/material/styles'
import { componentSizes } from '@theme/variables'

export const TopTabsNavigationContainer = styled('div')`
  display: flex;
  align-items: center;
  margin-left: ${componentSizes.smDistance};
  margin-bottom: ${componentSizes.smDistance};
  max-height: 48px;
`

export const TabsWrapper = styled('div')`
  max-width: 60%;
  margin-right: 40px;

  ${({ theme }: { theme: Theme }) => theme.breakpoints.down('md')} {
    margin-right: 10px;
    max-width: 80%;
  }
`

export const StyledAddIconWrapper = styled('div')`
  width: 12px;
  height: 12px;
  overflow: hidden;
`

export const ActionItemsWrapper = styled('div')`
  display: flex;
  align-items: center;
`
